import { Redirect, useParams, useRouteMatch } from 'react-router-dom';

// Old policy URLs (/privacy, /terms) now live under /legal with a side menu.
const ToLegal = () => {
  const { language } = useParams();
  const { path } = useRouteMatch();
  const doc = path.endsWith('/terms') ? 'terms' : 'privacy';
  return <Redirect to={`/${language}/legal/${doc}`} />;
};

export default ToLegal;
